import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { htmlToPlainText } from 'shared-helpers/common';

interface Props {
  children?: ReactNode;
  description?: string;
  subtitle?: ReactNode;
  title?: string;
}

const PathStepTileContent = ({
  children,
  description,
  subtitle,
  title
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="content">
      {title ? <div className="title">{title}</div> : null}

      {subtitle ? <div className="subtitle">{subtitle}</div> : null}

      {description ? (
        <div className="description">{htmlToPlainText(description)}</div>
      ) : null}

      {children}

      <style jsx>{`
        .content {
          display: flex;
          flex-direction: column;
          padding: 15px;
          min-height: 200px;
        }
        .title {
          color: ${theme.textColor};
          display: -webkit-box;
          font-size: 1.6rem;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .subtitle {
          color: ${theme.textColorLight};
          font-size: 1.3rem;
          font-weight: 600;
          margin-top: 3px;
        }
        .description {
          color: ${theme.textColorLight};
          display: -webkit-box;
          font-size: 1.4rem;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      `}</style>
    </div>
  );
};

export default PathStepTileContent;
